export { RedirectionService } from './services';
export { RedirectionResourceModule } from './RedirectionResourceModule';
